import { Link } from "react-router-dom";
import { Heart, ShoppingBag, X } from "lucide-react";
import { toast } from "sonner";
import { useWishlist } from "../contexts/WishlistContext";
import { useCart } from "../contexts/CartContext";
import { useLocale } from "../contexts/LocaleContext";

export default function Wishlist() {
  const { items, remove } = useWishlist();
  const { add } = useCart();
  const { fmt } = useLocale();
  if (items.length === 0) {
    return (
      <div className="max-w-2xl mx-auto px-6 py-32 text-center">
        <Heart className="mx-auto text-copper" size={36}/>
        <h1 className="font-display text-5xl text-dark mt-6">Your Wishlist is Empty</h1>
        <p className="text-gray-500 mt-4">Save your favorite timepieces for later.</p>
        <Link to="/shop" className="btn-primary mt-8">Browse Collection</Link>
      </div>
    );
  }
  return (
    <div className="max-w-[1300px] mx-auto px-6 md:px-12 py-14">
      <div className="overline mb-3">Saved Items</div>
      <h1 className="font-display text-5xl text-dark mb-10">Wishlist ({items.length})</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {items.map(i => (
          <div key={i.id} className="card-luxe group relative">
            <Link to={`/product/${i.id}`} className="block">
              <div className="aspect-square overflow-hidden bg-[#FAF7F2]">
                <img src={i.image} alt={i.name} className="w-full h-full object-cover"/>
              </div>
              <div className="p-4">
                <div className="text-[10px] uppercase tracking-luxe text-copper">{i.brand}</div>
                <div className="text-sm text-dark mt-1 line-clamp-2">{i.name}</div>
                <div className="text-sm text-gray-700 mt-1">{fmt(i.price)}</div>
              </div>
            </Link>
            <div className="px-4 pb-4 flex gap-2">
              <button onClick={()=>{add(i); toast.success("Added to cart");}} className="btn-primary flex-1 justify-center text-[10px]"><ShoppingBag size={11}/> Add</button>
              <button onClick={()=>remove(i.id)} className="btn-outline px-3"><X size={12}/></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
